import {  Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validator, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';


@Component({
  selector: 'dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.css']
})
export class DropdownComponent implements OnInit {

  selectedItems = [];
  dropdownSettings:IDropdownSettings = {};
  placeholder:string;
  placeholderText: string;
  
  public dropdownForm: FormGroup;

  items: any[] = [];

  @Output() selectedChange = new EventEmitter<any[]>();
  @Input() public required: boolean = false;
  @Input() public singleSelection: boolean = false;
  @Input() public showLabel: boolean = true;


  @Input() set selected(value: any[])
  {
    this.preSelect = value;
    if (this.dropdownForm) this.setPreSelect(value);
    };

  preSelect: any[];

  constructor(
    public translate: TranslateService,
    public fb: FormBuilder) {
      this.dropdownSettings = {
        singleSelection: true,
        idField: 'id',
        textField: 'name',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        closeDropDownOnSelection: false,
        allowRemoteDataSearch: false
      };
  }

  ngOnInit(): void {
    this.dropdownSettings.singleSelection = this.singleSelection;
    if (this.singleSelection)
      this.dropdownSettings.closeDropDownOnSelection = true;

    this.translate
    .get([this.placeholderText])
    .subscribe((translations: string) => {
      this.placeholder = translations[this.placeholderText];
    });

    this.dropdownForm = this.fb.group({
      selected: [[this.selectedItems], this.required ? Validators.required : []]
    });

    this.getItems();
  }

  getItems(): void {
    this.selectedItems = [];

  }

  onSelect(item: any){
    let s = this.selectedItems.map((it) => it.id);
    let its: any[] = this.items.filter((it) =>
    {
      return s.includes(it.id);
    });

    this.selectedChange.emit(its);
  }

  onSelectAll(event: any){
    let s = this.selectedItems.map((it) => it.id);

    this.selectedChange.emit(this.items);
  }

  onItemDeSelect(item: any){
    let s = this.selectedItems.map((it) => it.id);
    let its: any[] = this.items.filter((it) =>
    {
      return s.includes(it.id);
    });

    this.selectedChange.emit(its);
  }

  setPreSelect(items: any[])
  {
      this.selectedItems = [];
      if (items)
      {
        items.forEach(el => {
          if (el)
            this.selectedItems.push({id: el.id, name: el.name});
        });
      }
      if (this.dropdownForm)
      {
        this.dropdownForm.patchValue({
          selected: this.selectedItems
        });
      }
  }

  onFilterChange(filter: any)
  {
    console.log("catch the on search " + filter);
  }

}
